import { render } from "./DashboardNavigation.vue?vue&type=template&id=72447816"
const script = {}

import exportComponent from "C:\\Users\\Admin\\Desktop\\dev\\dma-scot-stakeholders\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__